import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAngularEvent, IController, IModule, IScope, ITimeoutService} from "angular";
import _ from "lodash";
import {SøkRessurs} from "felles/tjenester/ressurser/SøkRessurs";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "felles/tjenester/Kontekst";
import {gettextCatalog} from "angular-gettext";
import {Throttle} from "felles/tjenester/Throttle";
import {SøkTjeneste, TilgjengeligEntitet} from "felles/tjenester/modulspesifikke/SøkTjeneste";
import moment from "moment";

const css = require('./søk.scss');

/**
 *  Globalt søk i topplinjemeny
 */
export class SøkKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmSoek', {
              bindings: {},
              controller: SøkKontroller.forInjisering(),
              template: require('./søk.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$timeout,
            SøkRessurs.regNavn,
            SøkTjeneste.regNavn,
            Throttle.regNavn,
            regNavn.gettext.gettextCatalog,
            Kontekst.regNavn,
            SøkKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $timeout: ITimeoutService,
                private søkRessurs: SøkRessurs,
                private søkTjeneste: SøkTjeneste,
                private throttle: Throttle,
                private gettextCatalog: gettextCatalog,
                private kontekst: Kontekst) {
    }

    modell: Søkemodell;
    viserValg = false;
    viserResultater = false;
    viserLiknendeEntiteter = false;
    treff: l.SearchResponse;
    treffValgtForVisLiknende: l.SearchHit;

    antallPaagaendeSok = 0

    /** rotelementet vi registrerer klikk lytter på for å fange klikk utenfor søkeskjema */
    documentElement;
    klikkfangerRegistrert = false;


    keyUp($event) {
        if ($event.keyCode === 27) this.skjulResultat();
    }

    togleVisValg() {
        if (this.modell.valgErAktive) return; //ikke lukke valg-menyen dersom det bruker har gjort begrensninger
        this.viserValg = !this.viserValg;
    }

    visValg() {
        this.viserValg = true;
    }

    valgEndret() {
        this.modell.beregnValgStatus();
        this.utførSøk();
    }

    togleAlleGrupper() {
        this.modell.togleAlleGrupper();
        this.utførSøk();
    }

    togleAlleEntiteter() {
        this.modell.togleAlleEntiteter();
        this.utførSøk();
    }

    begrensTil(spesifikasjon:BegrensSøkTil){
        //console.debug('begrensTil', spesifikasjon);
        if (spesifikasjon.treffValgtForVisLiknende){
            this.viserLiknendeEntiteter = true;
            this.treffValgtForVisLiknende = spesifikasjon.treffValgtForVisLiknende;
            this.utførFinnLiknendeSøk(spesifikasjon.treffValgtForVisLiknende._id, spesifikasjon.treffValgtForVisLiknende._type);
            return;
        }

        if (spesifikasjon.gruppe) this.modell.velgKunGruppe(spesifikasjon.gruppe);
        if (spesifikasjon.entitet) this.modell.velgKunEntitet(spesifikasjon.entitet);
        this.visValg();
        this.utførSøk();
    }

    resetValg(){
        this.viserValg = false;
        this.modell.resetValg();
        this.utførSøk();
    }

    visResultat() {
        if (this.viserResultater) return;
        this.viserResultater = true;

        if (!this.klikkfangerRegistrert) {
            this.documentElement.on('click.wksoek', (event: IAngularEvent) => this.håndterKlikkUtenforSøkekontainer(event));
            this.klikkfangerRegistrert = true;
        }
    }

    skjulResultat() {
        this.viserResultater = false;

        this.documentElement.off('click.wksoek');
        this.klikkfangerRegistrert = false;
    }

    haandterKlikk($event) {
        //fordi vi har en ng-click på et element som omslutter et input felt
        //vil mellomrom trigge onclick - dette er beskrevet i github issue:
        //https://github.com/angular/angular.js/issues/16664
        //sørger her for å ignorere tasteklikk
        if  ($event.type==="keyup" || $event.type==="keydown" || $event.type === "keypress")
           return;

        $event.preventDefault();
        $event.stopPropagation();
    }

    gaaTilbakeTilSoekeresultat(){
        this.utførSøk();
    }

    entitetNavnFlertall(entitetType:string){
        return this.søkTjeneste.entitetBasertPåEsType(entitetType).navnFlertall;
    }

    $onInit(): void {
        /**
         * The root document element. This is used for attaching a top-level click handler to
         * close the options panel when a click outside said panel occurs. We use `documentElement`
         * instead of body because, when scrolling is disabled, some browsers consider the body element
         * to be completely off the screen and propagate events directly to the html element.
         */
        this.documentElement = angular.element(document.documentElement);

        this.initModell();
        this.lyttTilBrukerRelastet();
        // Frem til ES er raskere på søk i større grupper/avtaler bør man vente litt før søket kjøres i gang, så bruker rekker å skrive ferdig søkestreng
        let throttled = this.throttle.throttle(() => this.utførSøk(), 600);
        this.$scope.$watch(() => this.modell.spesifikasjon.soekestreng, (newVal, oldVal) => {
            throttled();
        });

    }

    $onDestroy(): void {
        this.antallPaagaendeSok = 0;
    }

    //private hjelpemetoder

    private initModell() {
        this.modell = new Søkemodell(this.kontekst.autentiserteGrupper(), this.søkTjeneste.tilgjengeligeEntiteter);
    }

    private lyttTilBrukerRelastet(){
        this.$scope.$on(Kontekst.brukerRelastetEvent, () => this.initModell());
    }

    private håndterKlikkUtenforSøkekontainer(event: IAngularEvent) {
        this.skjulResultat();
        this.$scope.$apply();
    }

    private utførSøk() {
        //console.info('utførSøk', this.modell.spesifikasjon.soekestreng);
        this.viserLiknendeEntiteter = false;
        if (this.modell.spesifikasjon.soekestreng.length <= 2) return;

        // En enkel måte å gi bruker et hint via spinner om at det pågår søk, noen ganger tar søkene tid og brukeren sletter og forsøker igjen og igjen #
        this.antallPaagaendeSok += 1;
        this.søkRessurs.søkAvansert(this.modell.somSøkSpesifikasjon()).$promise
          .then(res => this.håndterResultat(res))
          .finally(() => {
              if(this.antallPaagaendeSok > 0) this.antallPaagaendeSok -= 1;
          });
    }

    private utførFinnLiknendeSøk(id: string, type: string) {
        this.antallPaagaendeSok += 1;
        this.søkRessurs.finnLiknende(id, type).$promise
          .then(res => this.håndterResultat(res))
          .finally(() => {
              if(this.antallPaagaendeSok > 0) this.antallPaagaendeSok -= 1;
          });
    }

    private håndterResultat(respons: l.SearchResponse){
        this.treff = respons;
        this.visResultat();
    }

}

class Søkemodell {
    constructor(private grupper: l.EnkelGruppeModell[], public tilgjengeligeEntiteter: TilgjengeligEntitet[]) {
        this.initTilgjengeligeGrupper();
        this.beregnValgStatus();

        this.spesifikasjon = {soekestreng: '', periode:null, inkluderteEntiteter: [], inkluderteGrupper: []};
    }

    periode:Periodevalg = Periodevalg.evig;
    tilgjengeligeGrupper: { [gruppenavn: string]: { gruppe: l.EnkelGruppeModell[]; valgt: boolean } };
    alleGrupperValgt = true;
    ingenGrupperValgt = false;

    alleEntiteterValgt = true;
    ingenEntiteterValgt = false;

    /** sann dersom bruker har valgt begrensninger i grupper eller typer */
    valgErAktive = false;

    spesifikasjon: l.SøkSpesifikasjon;

    togleAlleGrupper() {
        const nyStatus = (!this.alleGrupperValgt && !this.ingenGrupperValgt) || this.ingenGrupperValgt;
        this.settAlleGrupperValgt(nyStatus);
        this.beregnValgStatus();
    }

    private settAlleGrupperValgt(nyStatus:boolean){
        _(this.tilgjengeligeGrupper).values().flatten().forEach(modell => {
            modell.valgt = nyStatus;
        });
    }

    togleAlleEntiteter() {
        const nyStatus = (!this.alleEntiteterValgt && !this.ingenEntiteterValgt) || this.ingenEntiteterValgt;
        this.settAlleTyperValgt(nyStatus);
        this.beregnValgStatus();
    }

    private settAlleTyperValgt(nyStatus:boolean){
        _(this.tilgjengeligeEntiteter).forEach(modell => {
            modell.valgt = nyStatus;
        });
    }

    resetValg(){
        this.periode = Periodevalg.evig;
        this.settAlleGrupperValgt(true);
        this.settAlleTyperValgt(true);
        this.beregnValgStatus();
    }

    beregnValgStatus() {
        const antallEntiteterValgt = _(this.tilgjengeligeEntiteter).filter(modell => modell.valgt).size();
        this.alleEntiteterValgt = this.tilgjengeligeEntiteter.length == antallEntiteterValgt;
        this.ingenEntiteterValgt = antallEntiteterValgt == 0;

        const alleGrupper = _(this.tilgjengeligeGrupper).values().flatten();
        const antallGrupperValgt = alleGrupper.filter(gruppemodell => gruppemodell.valgt).size();
        this.alleGrupperValgt = alleGrupper.size() == antallGrupperValgt;
        this.ingenGrupperValgt = antallGrupperValgt == 0;

        this.valgErAktive = !(this.alleEntiteterValgt && this.alleGrupperValgt);
    }

    velgKunGruppe(gruppeId:string){
        _(this.tilgjengeligeGrupper).values()
          .flatten()
          .forEach(gruppemodell => { gruppemodell.valgt = (<l.EnkelGruppeModell><any>gruppemodell.gruppe).id === gruppeId; });
        this.beregnValgStatus();
    }

    velgKunEntitet(entitet:string){
        _(this.tilgjengeligeEntiteter)
          .forEach(e => { e.valgt = _(e.esType).some(type => type === entitet); });
        this.beregnValgStatus();
    }

    somSøkSpesifikasjon(): l.SøkSpesifikasjon {
        this.spesifikasjon.periode = null;
        switch (this.periode) {
            case Periodevalg.sistemnd:
                this.spesifikasjon.periode = {start: moment().subtract(30, 'days').toDate(), slutt: moment().add(1, 'year').toDate()}
                break;
           case Periodevalg.sistehalvår:
                this.spesifikasjon.periode = {start: moment().subtract(178, 'days').toDate(), slutt: moment().add(1, 'year').toDate()}
               break;
            case Periodevalg.sisteår:
                this.spesifikasjon.periode = {start: moment().subtract(365, 'days').toDate(), slutt: moment().add(1, 'year').toDate()}
                break;
            case Periodevalg.evig:
                this.spesifikasjon.periode = null;
                break;
        }
        this.spesifikasjon.inkluderteGrupper = _(this.tilgjengeligeGrupper).values()
          .flatten()
          .filter(gruppemodell => gruppemodell.valgt)
          .map(gruppemodell => (<l.EnkelGruppeModell><any>gruppemodell.gruppe).id)
          .value();
        this.spesifikasjon.inkluderteEntiteter = _(this.tilgjengeligeEntiteter)
          .filter(entitet => entitet.valgt)
          .map(entitet => entitet.type)
          .value();
        return this.spesifikasjon;
    }

    private initTilgjengeligeGrupper() {
        this.tilgjengeligeGrupper = <any>_(this.grupper)
          .map(gruppe => ({gruppe: gruppe, valgt: true}))
          .groupBy(gruppemodell => gruppemodell.gruppe.organisasjonsnavn)
          .value();
    }
}

export interface BegrensSøkTil {
    gruppe?: string;
    entitet?: string;
    treffValgtForVisLiknende?: l.SearchHit;
}

enum Periodevalg {
    sistemnd='sistemnd',
    sistehalvår='sistehalvaar',
    sisteår='sisteaar',
    evig ='evig'
}
